// extracted by mini-css-extract-plugin
export var button = "_jx-0";
export var donut = "_jx-1";
export var donutFill = "_jx-3";
export var donutTrack = "_jx-2";